import { ReactComponent as SvgArrow } from '@img/icons/chevron-right.svg';
import * as React from 'react';
import S from './UspBanner.styles';
import { useInView } from '@hooks/useInView';
import { rootMargin } from '@helpers/animation';
import { useMedia } from 'react-use';
import { Device, until } from '@helpers/media';
const UspBanner = ({ items, ...props }) => {
    const [inViewRef, active] = useInView({
        rootMargin,
    });
    const mobileLayout = useMedia(items.length > 3 ? until(Device.DesktopSmall) : until(Device.TabletLarge));
    return (React.createElement(S.Container, { ref: inViewRef, id: props.id, flush: "both" },
        React.createElement(S.ItemList, { "data-in-view": active, "data-scroll-active": items.length !== 1, "data-scroll-active-on": items.length > 3 ? 'tablet-large' : 'tablet', style: {
                '--speed': `${items.length * 3}s`,
                '--count': items.length,
            } },
            items.map((item, i) => renderItem(item, i)),
            mobileLayout && items.length > 1 && items.map((item, i) => renderItem(item, i)))));
    function renderItem(item, i) {
        switch (item.type) {
            case 'linkable':
                return renderLinkableItem(item, i);
            case 'nonlinkable':
                return renderNonlinkableItem(item, i);
            case 'trustpilot':
                return renderTrustpilotItem(item, i);
        }
    }
    function renderLinkableItem(item, i) {
        return (React.createElement(S.Item, { key: item.id, as: "a", href: item.url, target: item.target, "data-type": item.type, style: { '--i': i + 1 } },
            React.createElement(S.IconWrapper, null,
                React.createElement(S.Icon, { alt: "", loading: "lazy", src: item.icon, width: "50", height: "40" })),
            React.createElement(S.Copy, null,
                item.title && React.createElement(S.Title, null, item.title),
                item.text && React.createElement(S.Text, null,
                    item.text,
                    " ",
                    React.createElement(S.Arrow, { as: SvgArrow })))));
    }
    function renderNonlinkableItem(item, i) {
        return (React.createElement(S.Item, { key: item.id, "data-type": item.type, style: { '--i': i + 1 } },
            React.createElement(S.IconWrapper, null,
                React.createElement(S.Icon, { alt: item.altText, loading: "lazy", src: item.icon, width: "60", height: "40", role: !item.altText ? 'presentation' : undefined })),
            React.createElement(S.Copy, null,
                item.title && React.createElement(S.Title, null, item.title),
                item.text && React.createElement(S.Text, null, item.text))));
    }
    function renderTrustpilotItem(item, i) {
        return (React.createElement(S.Item, { key: item.id, "data-type": item.type, style: { '--i': i + 1 } },
            React.createElement(S.IconWrapper, null,
                React.createElement(S.Icon, { alt: "", loading: "lazy", src: item.icon, width: "60", height: "40" })),
            React.createElement(S.Copy, null,
                React.createElement(S.Title, null,
                    item.title,
                    React.createElement(S.RatingImage, { alt: item.trustpilotRatingAltText, loading: "lazy", src: item.trustpilotRatingUrl })),
                item.text && React.createElement(S.Text, null, item.text))));
    }
};
export default UspBanner;
